import { WorkspaceSkeleton } from "./workspace-skeleton";

export function FullPageLoader() {
  console.log("[DIAG] FullPageLoader RENDER (root Suspense fallback active)");

  return <WorkspaceSkeleton />;
}
